import { style } from '@vanilla-extract/css';

/** Removes inline-SVG baseline gap so vertical spacing matches the design (flex-safe). */
export const svgRoot = style(
  {
    display: 'block',
  },
  'ai-gradient-sparkle-icon-svg',
);
